import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import type { IMessage } from './message';
import { messageSchema } from './message';
import type { IShowKeyboardPayload, IShowOptionsPayload } from '../user-input';
import {
  showKeyboardPayloadSchema,
  showOptionsPayloadSchema,
} from '../user-input';

export const COMMAND = 'DIALOGUE/COMMAND';

export interface ICommandPayload {
  commandId: string;
  conversationId: string;
  timestamp: number;
  message?: IMessage;
  keyboard?: IShowKeyboardPayload;
  options?: IShowOptionsPayload;
}

export const commandPayloadSchema = objectSchemaOf<ICommandPayload>({
  commandId: Joi.string().required(),
  conversationId: Joi.string().required(),
  timestamp: Joi.number().required(),
  message: messageSchema,
  keyboard: showKeyboardPayloadSchema,
  options: showOptionsPayloadSchema,
}).or('message', 'keyboard', 'options');

export interface ICommandAction {
  type: typeof COMMAND;
  payload: ICommandPayload;
}

export const commandActionSchema = objectSchemaOf<ICommandAction>({
  type: Joi.string().valid(COMMAND).required(),
  payload: commandPayloadSchema.required(),
});

export const command = actionCreator({
  type: COMMAND,
  schema: commandActionSchema,
});
